"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const opaque_1 = require("./framework/opaque");
exports.QuestionId = opaque_1.opaqueOfString();
var TestResolver;
(function (TestResolver) {
    TestResolver.AvailableLanguages = {
        fr: 'fr',
        en: 'en',
        cn: 'cn'
    };
})(TestResolver = exports.TestResolver || (exports.TestResolver = {}));
//# sourceMappingURL=models.js.map


//////////////////
// WEBPACK FOOTER
// ../models/dist/models.js
// module id = 726
// module chunks = 12